/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import { Modal } from 'react-responsive-modal';
import queryString from 'query-string';
import { Base64 } from 'js-base64';
import { isMobile } from 'react-device-detect';
import $ from 'jquery';
// import { clearCache } from "react-router-cache-route";
class Login extends Component {
  state = {
    userid: '',
    password: '',
    useridConfirm: false,
    passwordConfirm: false,
    loading: false,
    loginLoading: false,
    failMessage: '',
    chkValue: false,
    _focus: 0,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    // const { history, authId } = this.props;
    //console.log(history.location.pathname)

    if (window.addEventListener) {
      window.addEventListener('message', this._snsConnection);
    } else if (window.attachEvent) {
      window.attachEvent('message', this._snsConnection);
    }
    const aplsUid = localStorage.getItem('aplsUid');

    const ran = Math.random();
    const backNumber = Math.floor(ran * 2);

    //console.log(backNumber)

    if (aplsUid === '' || aplsUid === undefined || aplsUid === null) {
      setTimeout(() => {
        this.userid.focus();
      }, 500);

      this.setState({
        backNumber: backNumber,
      });
    } else {
      this.setState({
        userid: aplsUid,
        chkValue: true,
        backNumber: backNumber,
      });

      setTimeout(() => {
        this._onUserid();
      }, 500);
    }

    this._getBanner();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    if (window.addEventListener) {
      window.removeEventListener('message', this._snsConnection);
    } else if (window.attachEvent) {
      window.detachEvent('message', this._snsConnection);
    }
  };

  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const eventData = result.data[0].listData;

    if (intReturn === 0) {
      //let videoList = []
      //console.log(eventData[0].vodUrl)
      //if(eventData[0].vodUrl !== null && eventData[0].vodUrl !== null && eventData[0].vodUrl !== undefined) {
      //    videoList.push({url: eventData[0].vodUrl})
      //}

      //console.log(videoList)
      if (this._isMounted) {
        this.setState({
          eventData,
          //videoList
        });
      }

      this._bannerView(
        eventData[0].idx,
        eventData[0].adComIdx,
        eventData[0].pageCode
      );
      //노출수
      //console.log('==> 베너 노출')
      //console.log(eventData[0].idx, eventData[0].adComIdx)

      //videoList.push({url: 'https://jjmp4.ofscdn.com/PV/' + eventData[0].vodUrl})
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/loginBanner')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _bannerView = async (idx, adComIdx, pageCode) => {
    if (adComIdx === null || adComIdx === undefined || adComIdx === '') {
    } else {
      if (adComIdx !== 1) {
        const result = await this._bannerViewApi(idx, adComIdx, pageCode);
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          //console.log('banner view history...')
        }
      }
    }
  };
  _bannerViewApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerView', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _bannerClickApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerClick', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };

  _snsConnection = (e) => {
    ////console.log(e.origin)
    ////console.log(e.data[0])
    const url = e.origin;
    const { loginId } = this.props;

    if (url === 'https://api.aniplustv.com:3100') {
      if (loginId === '' || loginId === null || loginId === undefined) {
        if (e.data[0] === undefined || e.data[0] === null || e.data[0] === '') {
        } else {
          const callbackPart = e.data[0].callbackPart;
          const intReturn = e.data[0].intReturn;
          const snsName = e.data[0].part;
          if (callbackPart === 'SNS') {
            if (intReturn === '0') {
              const userid = e.data[0].userid;
              const password = e.data[0].password;
              if (this._isMounted) {
                this.setState({
                  userid,
                  password,
                  useridConfirm: true,
                });
              }

              this._onLogin();
            } else if (intReturn === '-1') {
              toast.error(
                snsName +
                  '로그인으로 등록된 계정이 존재하지 않습니다. 등록 후 이용해 주세요'
              );
            } else if (intReturn === '-100') {
              toast.error('SNS 계정 조회중 오류가 발생했습니다.');
            } else {
              toast.error('SNS 계정 조회중 오류가 발생했습니다.');
            }
          }
        }
      } else {
        toast.info('이미 로그인된 상태입니다.');
      }
    }

    //const a = e.data[0].callbackPart
    //e.data.
    //e.source.postMessage(‘hi’, ‘http://ohgyun.com'); 메세지를 받은 곳으로 재전송...
  };
  _onUseridChange = (e) => {
    ////console.log(e.target.value)
    this.setState({
      userid: e.target.value,
    });
  };
  _onPasswordChange = (e) => {
    this.setState({
      password: e.target.value,
    });
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }

    //console.log(expires)
    document.cookie =
      name +
      '=' +
      value +
      ';path=/;expires=' +
      expires +
      '; domain=aniplustv.com; SameSite=None; Secure;'; // SameSite=None; Secure; 실서비스 시 추가할 것.
  };
  _onLogin = async () => {
    const {
      setAParam,

      setAuthId,
      setLoginId,
      setData,
      setBitrate,
      setDownloadBitrate,
      setAutoNext,
      setPlayer,
      setPkg,
      setIcon,
      setNicName,
      history,

      setPollShow,
    } = this.props;
    const { userid, password, chkValue } = this.state;

    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    console.log(query);
    const refer = query.r;
    const param = query.p;
    // console.log(refer)

    if (userid === '' || userid === undefined || userid === null) {
      toast.warn('아이디를 입력해 주세요');
      return false;
    }
    if (password === '' || password === undefined || password === null) {
      toast.warn('패스워드를 입력해 주세요');
      return false;
      //alert('패스워드가 누락되었습니다.')
    }

    const result = await this._onLoginApi();
    const intReturn = result.data[0].intReturn;
    // const messageCount = result.data[0].messageCount;
    const icon = result.data[0].charac_Img;

    const listData = result.data[0].listData;
    ////console.log(intReturn)
    ////console.log(listData)
    ////console.log(icon)
    //console.log(result.data[0].pkg)

    if (intReturn === 0) {
      //cookies
      const at = result.data[0].at;
      const rt = result.data[0].rt;
      const base64Data = await this._getBase64Encode(userid, listData[0].pkg);

      //console.log(at)
      //console.log(rt)
      console.log(base64Data.data.codeString);
      if (
        base64Data.data.codeString === '' ||
        base64Data.data.codeString === null ||
        base64Data.data.codeString === undefined
      ) {
        toast.error('오류가 발생했습니다. 다시 시도해 주세요');
        this.setState({
          loginLoading: false,
        });
      } else {
        //
        const authId1 = base64Data.data.codeString; /*소핑몰과 연동됨 */

        const authId = Base64.encode(userid);
        //console.log(Base64.encode('badguyson'))
        //console.log(await this._getBase64Encode('badguyson'))
        //console.log(Base64.decode('YWRtaW4='))

        localStorage.setItem('at', at);
        localStorage.setItem('rt', rt);

        let expires = new Date();
        expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14);
        let cookieData =
          'messageCount_output=' +
          listData[0].bitrate +
          '&birthDay=' +
          listData[0].birthDay +
          '&memberPartCode=' +
          listData[0].download +
          '&authId=' +
          authId1 +
          '&playerFlag=' +
          listData[0].playerFlag +
          '&couponCount=' +
          listData[0].autoNext +
          '&jumin=' +
          listData[0].jumin +
          '&point=' +
          listData[0].point +
          '&sex=' +
          listData[0].sex +
          '&loginCode=' +
          listData[0].loginCode +
          '&loginId=' +
          userid +
          '&pkg=' +
          listData[0].pkg +
          '&loginName=' +
          encodeURIComponent(listData[0].nicName);
        ////console.log(cookieData)
        this.setCookie('account', cookieData);
        this.setCookie('ad', authId);
        this.setCookie('at', at);
        this.setCookie('rt', rt);
        this.setCookie('ni', encodeURIComponent(listData[0].nicName));
        this.setCookie('ic', icon);

        //const pollIdx = listData[0].pollIdx
        //const pollEndIdx = listData[0].pollEndIdx

        const pollIdx = 0;
        const pollEndIdx = 100;

        //console.log(authId)

        setAuthId(authId);
        setAParam(authId1);
        setLoginId(userid);
        setData(listData);
        setIcon(icon);

        setBitrate(listData[0].bitrate);
        setDownloadBitrate(listData[0].download);
        setAutoNext(listData[0].autoNext);
        setPlayer(listData[0].player);
        setNicName(listData[0].nicName);
        setPkg(listData[0].pkg);

        if (chkValue) {
          ////console.log('local storage...save')
          localStorage.setItem('aplsUid', userid);
        } else {
          localStorage.removeItem('aplsUid');
        }

        this.setState({
          loginLoading: false,
        });

        if (pollEndIdx > 0) {
          //이미투표했음.
          setPollShow(0);
        } else {
          setPollShow(pollIdx);
        }

        setTimeout(() => {
          // if ( document.referrer ) {
          if (refer === 's') {
            if (param === undefined || param === '' || param === null) {
              document.location.href = 'https://shop.aniplustv.com';
            } else {
              document.location.href = 'https://shop.aniplustv.com' + param;
            }
          } else if (refer === 'a') {
            if (param === undefined || param === '' || param === null) {
              document.location.href = 'https://aketo.aniplustv.com';
            } else {
              document.location.href = 'https://aketo.aniplustv.com' + param;
            }
          } else if (refer === 'd') {
            if (param === undefined || param === '' || param === null) {
              document.location.href = 'https://devshop.aniplustv.com';
            } else {
              document.location.href = 'https://devshop.aniplustv.com' + param;
            }
          } else if (refer === 'ms') {
            document.location.href = 'https://mshop.aniplustv.com';
          } else if (refer === 't') {
            document.location.href = 'https://www.aniplustv.com/seat/seat.asp';
          } else {
            //history.go(-1, {from: 'login'})
            //clearCache()
            //console.log(document.referrer);
            console.log(history);
            console.log(history.length);
            console.log(history.location.pathname);
            // history.length <= 1 ? history.replace('/') : history.goBack();

            if (history.location.pathname === '/login') {
              // window.location.href = '/';
              history.goBack();
              // history.replace('/');
            } else {
              // history.goBack();
              // history.replace(history.location.pathname);
              history.length <= 1 ? history.replace('/') : history.goBack();
            }
            setTimeout(() => {
              $('html').css({
                width: '100%',
                position: '',
                top: '',
                overflow: '',
              });
            }, 700);

            //  history.length <= 1 ?

            //     ? history.goBack()
            //     : history.push('/'); //history.push('/')
          }
          //} else {

          //}
        }, 300);
        /*
                if(listData[0].autoPriceAgree === 'A' || listData[0].autoPriceAgree === 'Y') {
                    toast.success('정상적으로 로그인 되었습니다.')
                    
                    setTimeout(() => {
                        history.goBack()
                    }, 600)
                } else if(listData[0].autoPriceAgree === 'N') {
                    //동의 팝업.
                    setTimeout(() => {
                        history.goBack()
                    }, 600)
                    setAgreeShow(true)
                }
                */
        //
      }
    } else {
      //alert('계정이 일치하지 않습니다.')
      toast.error('계정이 일치하지 않습니다.');
      this.setState({
        loginLoading: false,
      });
    }
  };
  _getB64e = (codeString) => {
    const { aspUrl } = this.props;
    return axios(aspUrl + '/b64e.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Encode = (codeString, pkg) => {
    const { aspUrl } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        codeString
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onLoginApi = () => {
    const { apiUrl } = this.props;
    const { userid, password } = this.state;
    this.setState({
      loginLoading: true,
    });
    ////console.log(userid)
    //return axios(apiUrl + '/_onUserid?userid=' + userid)
    //loadProgressBar()
    //return axios.post(aspUrl + '/loginPost.asp', {
    return axios
      .post(apiUrl + '/_onLogin', {
        params: {
          userid: userid,
          password: password,
        },
      })

      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _onUserid = async () => {
    const { userid } = this.state;
    if (userid === null || userid === undefined || userid === '') {
      //alert('로그인 후 이용해 주세요')
      //toast.warn('아이디가 누락 되었습니다.')
    } else {
      const result = await this._onUseridApi();
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        this.setState({
          loading: false,
          useridConfirm: true,
          failMessage: '',
        });

        /*
                setTimeout(() => {
                    this.password.focus()
                }, 600)
                */
      } else {
        this.setState({
          loading: false,
          useridConfirm: false,
          failMessage: '존재하지 않는 계정입니다.',
        });

        toast.error('존재하지 않는 계정입니다.');
      }
    }
  };
  _onUseridApi = () => {
    const { apiUrl } = this.props;
    const { userid } = this.state;
    this.setState({
      loading: true,
    });
    ////console.log(userid)
    //return axios(apiUrl + '/_onUserid?userid=' + userid)

    return axios
      .post(apiUrl + '/_onUserid', {
        params: {
          userid: userid,
        },
      })

      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _onNaver = () => {
    const { apiUrl, loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      window.open(apiUrl + '/naver/auth', '', '');
    }
  };
  _onKakao = () => {
    const { apiUrl, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      window.open(apiUrl + '/kakao/auth', '', '');
    }
  };
  _onFacebook = () => {
    const { apiUrl, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      window.open(apiUrl + '/facebook/auth', '', '');
    }
  };
  _onGoogle = () => {
    const { apiUrl, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      window.open(apiUrl + '/google/auth', '', '');
    }
  };
  _onTwitter = () => {
    const { apiUrl, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      window.open(apiUrl + '/twitter/auth', '', '');
    }
  };
  _onLogout = () => {
    const { setLoginId, setAuthId, history } = this.props;

    this.setCookie('account', '');
    this.setCookie('ad', '');
    this.setCookie('at', '');
    this.setCookie('rt', '');
    this.setCookie('ni', '');
    this.setCookie('ic', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    history.push('/');
  };
  _chkValue = (e) => {
    //console.log(e.target.checked)
    //const { chkValue } = this.state
    this.setState({
      chkValue: e.target.checked,
    });
  };
  _enterKey = (e) => {
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      this._onLogin();
    }
  };
  _onGoEvent = () => {
    const { eventData } = this.state;
    const { history } = this.props;

    if (eventData[0].Linktarget === '_blank') {
      window.open(eventData[0].LinkURL, '', '');
    } else {
      history.push(eventData[0].LinkUR);
    }

    /*
        if(backNumber === 1) {
            //setEventIdx(279)
           // window.open('https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=93&event_id=8', '', '')
            //window.open('https://www.cgv.co.kr/movies/detail-view/?midx=84361', '', '')
           //setEventIdx(287)
            
            window.open('https://shop.aniplustv.com/cafe/31', '', '')
            //window.open('https://www.megabox.co.kr/movie-detail?rpstMovieNo=21068600', '', '')
        } else {
            window.open('https://shop.aniplustv.com/cafe/30', '', '')
            //window.open('https://www.megabox.co.kr/movie-detail?rpstMovieNo=21054000', '', '')
            //setEventIdx(284)
            //history.push('/tlist?ts=7')
        }
        */
  };

  render() {
    // const { icon } = this.props;
    const {
      userid,
      password,
      useridConfirm,

      loginLoading,
      chkValue,
      eventData,
      _foucs,
    } = this.state;
    const { imgUrl } = this.props;
    ////console.log(icon)

    return (
      <Fragment>
        <div
          className="login_container"
          style={
            eventData
              ? {
                  background:
                    'url(https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' +
                    eventData[0].bannerFile +
                    ') no-repeat center top',
                }
              : { background: 'url()' }
          }
        >
          <div className="login_logo">
            <Link to="/">
              <img src={imgUrl + '/img/login_img/login_logo.png'} />
            </Link>
          </div>
          <div className="join_btn">
            <Link to="/join">회원가입</Link>
          </div>
          {/*클릭*/}
          {eventData ? (
            <img
              src={
                'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' +
                eventData[0].bannerFile_s
              }
              className="open_img"
              style={{ cursor: 'pointer' }}
              onClick={this._onGoEvent}
            />
          ) : null}
          <div className="login_content width1">
            <div className="login_padding">
              <h1>로그인</h1>
              <ul>
                <li className={_foucs === 1 && 'on'}>
                  <input
                    name="userid"
                    value={userid}
                    onChange={this._onUseridChange}
                    type="text"
                    className="common_input login_input"
                    placeholder="아이디를 입력하세요."
                    autoFocus
                    // onBlur={this._onUserid}
                    ref={(ref) => (this.userid = ref)}
                    onFocus={() => this.setState({ _foucs: 1 })}
                    onBlur={() => this.setState({ _foucs: 0 })}
                  />
                </li>
                {
                  /*useridConfirm ? (*/
                  <li className={_foucs === 2 && 'on'}>
                    <input
                      type="password"
                      name="password"
                      value={password}
                      onChange={this._onPasswordChange}
                      onKeyUp={this._enterKey}
                      className="common_input login_input"
                      placeholder="비밀번호 (5~20자 영문, 숫자입력)"
                      ref={(ref) => (this.password = ref)}
                      /*readOnly={useridConfirm ? false : true}*/

                      onFocus={() => this.setState({ _foucs: 2 })}
                      onBlur={() => this.setState({ _foucs: 2 })}
                    />
                  </li>
                  /*) : null */
                }
              </ul>
              <div className="div_btn">
                <div className="chek_group">
                  <input
                    name="선택"
                    id="checkbox_1"
                    type="checkbox"
                    checked={chkValue}
                    className="checkbox_img"
                    onChange={this._chkValue}
                  />
                  <label htmlFor="checkbox_1">아이디 기억하기</label>
                </div>
                <Link to="/find">ID/PW 찾기</Link>
              </div>
              {/* {useridConfirm ? ( */}
              <div className="login_btn">
                <a style={{ cursor: 'pointer' }} onClick={this._onLogin}>
                  로그인
                </a>
              </div>
              {/* ) : null} */}
              <div className="etc_login">
                {isMobile ? (
                  <h2>
                    다른 방법으로 로그인하기
                    <br />
                    (회원가입시 등록된 계정으로만 이용가능)
                  </h2>
                ) : (
                  <h2>
                    다른 방법으로 로그인하기(회원가입시 등록된 계정으로만
                    이용가능)
                  </h2>
                )}

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <a style={{ cursor: 'pointer' }} onClick={this._onTwitter}>
                    <img src={imgUrl + '/img/login_img/etc_login_01.png'} />
                  </a>
                  {/* <a style={{ cursor: 'pointer' }} onClick={this._onFacebook}>
                    <img src={imgUrl + '/img/login_img/etc_login_02.png'} />
                  </a> */}
                  <a style={{ cursor: 'pointer' }} onClick={this._onGoogle}>
                    <img src={imgUrl + '/img/login_img/etc_login_03.png'} />
                  </a>
                  <a style={{ cursor: 'pointer' }} onClick={this._onKakao}>
                    <img src={imgUrl + '/img/login_img/etc_login_04.png'} />
                  </a>
                  <a style={{ cursor: 'pointer' }} onClick={this._onNaver}>
                    <img src={imgUrl + '/img/login_img/etc_login_05.png'} />
                  </a>
                </div>
              </div>
              <div className="etc_join">
                <span>ANIPLUS 회원이 아니신가요? </span>
                <Link to="join">지금 회원가입하세요.</Link>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={loginLoading}
          showCloseIcon={false}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <img src={imgUrl + '/img/vod/vod_loading.png'} />
        </Modal>

        {/*
                <div style={{backgroundColor: '#ffffff'}}>
                    <div>
                        userid : <input type = "text" name="userid" value={userid} onChange = {this._onUseridChange} readOnly={useridConfirm ? true : false }/> 
                        { useridConfirm ? null : (
                            <button onClick = {this._onUserid}>
                                { loading && (<i className="fa fa-refresh fa-spin" />) }
                                아이디 확인
                            </button>
                        )}
                        {failMessage !== '' && (
                            <div style={{color: 'red', fontSize: 12}}>{failMessage}</div>
                        )}
                    </div>
                    { useridConfirm ? (
                        <Fragment>
                            password: <input type = "password" name="password" value={password} onChange = {this._onPasswordChange}/>
                            <button onClick = {this._onLogin}>
                                { loginLoading && (<i className="fa fa-refresh fa-spin" />) }
                                로그인
                            </button>
                        </Fragment>
                    ) : null }
                    
                    <div onClick={this._onNaver}>
                        Naver Login
                    </div>
                    <div onClick={this._onKakao}>
                        Kakao Login
                    </div>
                    <div onClick={this._onFacebook}>
                        Facebook Login
                    </div>
                    { icon ? (
                        <img src={icon} />
                    ) : null}
                    <div onClick={this._onLogout}>
                        Logout
                    </div>
                </div>
                */}

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Login));
